import React$1 from 'react';

const Facebook = () => /*#__PURE__*/React$1.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "40",
  height: "40"
}, /*#__PURE__*/React$1.createElement("defs", null, /*#__PURE__*/React$1.createElement("path", {
  id: "a",
  d: "M.002.002h39.683v39.755H.002z"
})), /*#__PURE__*/React$1.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React$1.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React$1.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React$1.createElement("path", {
  fill: "#FF005F",
  d: "M40 20.159C40 9.025 31.046 0 20 0S0 9.025 0 20.159C0 30.22 7.314 38.56 16.875 40.073V25.986h-5.078v-5.827h5.078v-4.441c0-5.053 2.986-7.843 7.554-7.843 2.188 0 4.477.393 4.477.393v4.961h-2.522c-2.484 0-3.259 1.554-3.259 3.148v3.782h5.547l-.887 5.827h-4.66v14.087C32.686 38.56 40 30.22 40 20.159",
  mask: "url(#b)"
})));

export default Facebook;
